<template>
    <transition name="modal">
        <div class="modal-mask">
            <div
                class="modal-wrapper"
                :class="{
                    'wide-modal': wide,
                }"
                v-if="withDetails">
                <div
                    class="modal-container"
                    :class="{
                        'sm-padding': smPadding,
                    }"
                    @scroll="$emit('contentScroll')"
                    v-on-clickaway="onClickawayClose">
                    <a class="modal-close icon-link" v-if="showCloseButton" @click="onClose"> &times; </a>
                    <div class="modal-header">
                        <slot name="header">
                            <!-- default header -->
                        </slot>
                        <CustomSeparator v-if="$slots.header" class="modal-title-separator" />
                    </div>

                    <div class="modal-body">
                        <slot name="body"> default body </slot>
                    </div>

                    <div class="modal-footer">
                        <slot name="footer">
                            <!-- default footer -->
                        </slot>
                    </div>
                </div>
            </div>
            <template v-else>
                <div class="text-center my-auto d-flex flex-column no-style-modal" v-on-clickaway="onClose">
                    <slot name="body"> default body </slot>
                </div>
            </template>
        </div>
    </transition>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway2';

const CustomSeparator = () => import('@components/partials/CustomSeparator.vue');

export default {
    components: {
        CustomSeparator,
    },
    props: {
        showCloseButton: {
            type: Boolean,
            required: false,
            default: true,
        },
        wide: {
            type: Boolean,
            default: false,
        },
        smPadding: {
            type: Boolean,
            default: false,
        },
        withDetails: {
            type: Boolean,
            default: true,
        },
        closeOnClickaway: {
            type: Boolean,
            default: false,
        },
    },
    mounted() {
        this.$nextTick(() => {
            document.body.appendChild(this.$el);
            document.body.classList.add('modal-active');
            document.addEventListener('keydown', this.onEscapeKey);
        });
    },
    beforeDestroy() {
        document.body.classList.remove('modal-active');
        document.removeEventListener('keydown', this.onEscapeKey);
    },
    directives: {
        onClickaway,
    },
    methods: {
        onEscapeKey(event) {
            if (event.key === 'Escape' || event.key === 'Esc') {
                this.onClose();
            }
        },
        onClose() {
            this.$emit('close');
            document.body.classList.remove('modal-active');
        },
        onClickawayClose() {
            if (this.withDetails && !this.closeOnClickaway) {
                return;
            }
            this.$emit('close');
            document.body.classList.remove('modal-active');
        },
    },
};
</script>
